import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import SingleState from '../states/single.state';

interface LiveData {
    [key: string]: any;
}

const initialState: SingleState = {
    data: {},
    loading: false,
    error: null,
};

const liveSlice = createSlice({
    name: 'live',
    initialState,
    reducers: {
        setLiveData: (state, action: PayloadAction<LiveData>) => {
            return {
                ...state,
                data: action.payload
            };
        },
        resetLiveData: (state) => {
            return {
                ...state,
                data: {}
            };
        },
    },
});

export const { setLiveData, resetLiveData } = liveSlice.actions;
export default liveSlice.reducer;
